import getLocalStorage from 'src/helpers/getLocalStorage'
import { usePersistedUserData } from 'src/hooks'
import useActions from 'src/hooks/useActions'

const useShouldDisplayUpsateTimestamp = () => {
  const actions = useActions()
  const {
    controlData: { upsaleDisplayedAt },
  } = usePersistedUserData()
  const storage = getLocalStorage()
  const key = 'AppUpsaleTimestamp'

  const setUpsaleTimestamp = () => {
    const now = (Date.now() / 1000).toString()
    if (storage) {
      storage.setItem(key, now)
    } else {
      actions.setUpsaleDisplayedAt(String(now))
    }
  }

  /**
   *
   * @param timeRange in seconds
   * @returns
   */
  const shouldDisplayUpsale = (timeRange: number) => {
    const lastViewed = storage ? storage.getItem(key) : upsaleDisplayedAt
    if (!lastViewed) return true

    const now = Date.now() / 1000
    return now - parseInt(lastViewed, 10) > timeRange
  }

  return {
    setUpsaleTimestamp,
    shouldDisplayUpsale,
  }
}

export default useShouldDisplayUpsateTimestamp
